<!-- Loading placeholder -->
<div class="placeholder video-placeholder" *ngIf="(!thumbnail || !thumbnail.source) && placeholder"></div>

<!-- Team Selection Overlay -->
<div
  class="overlay"
  (click)="onTeamSelectionClick($event)"
  *ngIf="askForTeam && !purchaseOverlay && forbiddenTeam"
></div>

<!-- Archived Overlay -->
<div class="overlay" (click)="onUnarchiveContactClick($event)" *ngIf="archived"></div>

<div
  class="video-card"
  [class.details-right]="detailsPosition === 'right'"
  (click)="triggerSelected($event)"
  *ngIf="thumbnail?.link || videoDetails[0]?.text || processing"
>
  <ng-container>
    <div class="video-card__thumbnail-container" [class.small-card]="detailsPosition === 'right'">
      <ng-container *ngIf="!thumbnail?.link">
        <ng-container *ngTemplateOutlet="videoThumbnail"></ng-container>
      </ng-container>
      <a
        *ngIf="thumbnail?.link"
        [routerLink]="thumbnail?.link"
        [queryParams]="thumbnail?.linkParams"
        class="no-transparency--link"
      >
        <ng-container *ngTemplateOutlet="videoThumbnail"></ng-container>
      </a>

      <ng-template #videoThumbnail>
        <img
          #thumbnailImg
          [lazyLoad]="thumbnail?.source"
          class="video-card__thumbnail"
          alt=""
          onerror="this.style.opacity='0';"
          (load)="onThumbnailLoad($event, videoDetails[0]?.text || 'Video image')"
        />
        <span class="remove flex justify-center items-center" *ngIf="removable" (click)="onRemoveVideoClick($event)">
          <svg-icon src="assets/images/svg/rebrand/bookmark.svg"></svg-icon>
          <span>Remove</span>
        </span>
      </ng-template>
      <img
        *ngIf="showNewVideoOverlay"
        [lazyLoad]="'assets/images/svg/icons/misc/new-video.svg'"
        class="video-card__new-overlay"
        alt="New video"
      />
      <div *ngIf="showBreakdownIcon" class="breakdown-button">
        <a [routerLink]="thumbnail?.link" class="flex items-center text-gold bg-navy text-sm font-semibold">
          <svg-icon class="mr-5" [src]="'/assets/images/svg/rebrand/breakdown.svg'"></svg-icon>
          <span>Breakdown</span>
        </a>
      </div>

      <!-- Purchase event overlay -->
      <div class="video__hover video-hover-purchase" *ngIf="purchaseOverlay">
        <div class="video-hover__content">
          <span class="video-hover__title">Purchase this event to download and watch film</span>
          <a [routerLink]="purchaseOverlay" class="no-transparency--link">
            <button class="btn">
              <span>Purchase Event Film</span>
            </button>
          </a>
        </div>
      </div>

      <!-- Add to library overlay -->
      <div class="video__hover video-hover-purchase" *ngIf="!purchaseOverlay && addToLibraryOverlay">
        <div class="video-hover__content">
          <span class="video-hover__title">Add this event to library to download and watch film</span>
          <a [routerLink]="addToLibraryOverlay" class="no-transparency--link">
            <button class="btn">
              <span>Add to Library</span>
            </button>
          </a>
        </div>
      </div>

      <!-- Team Access Overlay -->
      <div
        class="video__hover video-hover-purchase"
        *ngIf="!purchaseOverlay && !addToLibraryOverlay && forbiddenTeam && !askForTeam"
      >
        <div class="video-hover__content">
          <span class="video-hover__title">These teams were not selected for this event</span>
          <button class="btn" (click)="onForbiddenTeamClick($event)">
            <span>Find Out More</span>
          </button>
        </div>
      </div>

      <!-- Processing / Transcoding overlay -->
      <ng-container *ngIf="processing">
        <div class="video-overlay video-overlay-processing">
          <div class="video-overlay__content">
            <span class="video-overlay__title">Processing video...</span>
            <span class="video-overlay__title">This could take up to 1 hour</span>
          </div>
        </div>
      </ng-container>

      <!-- Playing now Overlay -->
      <div class="video-overlay" *ngIf="playingNowOverlay">
        <div class="video-overlay__content">
          <span class="video-overlay__title playing-now__title text-white">Playing Now</span>
        </div>
      </div>

      <!-- Archived Overlay -->
      <div
        class="video__hover video-hover-purchase"
        *ngIf="!purchaseOverlay && !addToLibraryOverlay && !askForTeam && !forbiddenTeam && archived"
      >
        <div class="video-hover__content">
          <span class="video-hover__title font-semibold">Game is Archived</span>
          <button class="btn" (click)="onUnarchiveContactClick($event)">
            <span>Contact Us <span *ngIf="detailsPosition !== 'right'">For Access</span></span>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="videoDetails.length" class="video-card__data flex">
      <div class="video-card__details" [class.mt-13]="detailsPosition !== 'right'" [class.line-clamp]="lineClamp">
        <ng-container *ngFor="let details of videoDetails; first as isFirst">
          <ng-container *ngIf="!details?.link">
            <ng-container *ngTemplateOutlet="detailsItem"></ng-container>
          </ng-container>
          <a *ngIf="details?.link" [routerLink]="details?.link" [queryParams]="details?.linkParams">
            <ng-container *ngTemplateOutlet="detailsItem"></ng-container>
          </a>
          <ng-template #detailsItem>
            <div [class.mt-4]="!isFirst">{{ details?.text }}</div>
          </ng-template>
        </ng-container>
      </div>
      <div *ngIf="showLockIcon" class="ml-5" [class.mt-13]="detailsPosition !== 'right'">
        <svg-icon src="assets/images/svg/icons/misc/lock-min.svg"></svg-icon>
      </div>
      <div
        *ngIf="showToggleHideStatus"
        class="lock-layout ml-5 hide-checkbox"
        [class.mt-13]="detailsPosition !== 'right'"
      >
        <div class="input input-checkbox checkbox-xs" (click)="onClickHideClip($event)">
          <label>
            <input [checked]="hideChecked" type="checkbox" />
            <span class="selector"></span>
            <span class="label">Hide</span>
          </label>
        </div>
      </div>
    </div>
  </ng-container>
</div>
